import {
  Avatar,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { useFfnStore } from "../store/FfnStore";

/** Splash card describing the proposed activity the 50.59 record will review. */
const FfnActivityCard = () => {
  const {
    activityTitle,
    setActivityTitle,
    activityDescription,
    setActivityDescription,
  } = useFfnStore();

  return (
    <Card elevation={2}>
      <CardContent>
        <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
          <Avatar
            sx={{
              width: 28,
              height: 28,
              fontSize: "0.875rem",
              bgcolor: "primary.main",
            }}
          >
            2
          </Avatar>
          <AssignmentIcon color="primary" />
          <Typography variant="h6" component="h2">
            Proposed activity
          </Typography>
        </Stack>
        <Stack spacing={2}>
          <TextField
            fullWidth
            size="small"
            label="Title"
            placeholder="e.g. Replace HPCI analog controller with digital upgrade"
            value={activityTitle}
            onChange={(e) => setActivityTitle(e.target.value)}
            data-testid="ffn-input-activity-title"
          />
          <TextField
            fullWidth
            multiline
            minRows={4}
            label="Activity description"
            placeholder="Describe the change, test, or experiment in enough detail for the applicability determination…"
            value={activityDescription}
            onChange={(e) => setActivityDescription(e.target.value)}
            data-testid="ffn-input-activity-description"
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default FfnActivityCard;
